import { render, staticRenderFns } from "./nonAktif.vue?vue&type=template&id=77eef906"
import script from "./nonAktif.vue?vue&type=script&lang=js"
export * from "./nonAktif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports